import { useRef, useEffect } from 'react';

const HeroSection = () => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative h-screen overflow-hidden">
      <video
        ref={videoRef}
        src="videos/HeroVideoFinal.mp4"
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/55" />

      {/* Subtle bottom gradient blending into next section */}
      <div
        className="absolute inset-0 z-10 pointer-events-none"
        style={{
          background: 'linear-gradient(180deg, transparent 0%, transparent 60%, rgba(247,249,252,0.6) 85%, rgba(247,249,252,1) 100%)',
        }}
      />

      <div className="relative h-full flex items-center justify-center z-10">
        <div className="text-center px-6 max-w-5xl w-full">
          <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-bold mb-6">
            Fractional CTO &amp; Technology Leadership
          </h1>
          <p className="text-white/90 text-lg md:text-xl max-w-4xl mx-auto mb-8 leading-relaxed">
            Helping companies deliver complex technology initiatives, modernize software systems, and scale engineering teams — without hiring a full-time CTO.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <button
              onClick={scrollToContact}
              className="relative bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-medium transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_20px_rgba(59,130,246,0.5)] whitespace-nowrap cursor-pointer"
            >
              Schedule a Consultation
            </button>
          </div>
          <p className="text-white/75 text-xs md:text-sm max-w-3xl mx-auto leading-relaxed">
            Hundreds of projects completed with companies across healthcare, logistics, finance, retail, manufacturing, real estate, government, education, hospitality and travel.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
